module.exports = __webpack_public_path__ + "static/media/6.6e916ae7.jpg";